export default {
  Home: {
    title:
      "Projetsolaire.com {'|'} Installer Panneaux Solaires avec Artisan RGE",
    description:
      "Avec projetsolaire.com, découvrez 3+ devis gratuits à -40% des prix du marché, de milliers d'artisans photovoltaïques et batteries en autoconsommation.",
    //title: "Projetsolaire.com {'|'} Plateforme communautaire d'énergie solaire",
    //description: "Avec projetsolaire.com, découvrez 3+ devis gratuits photovoltaïque à -40% des prix du marché, d'artisans de panneaux solaires et batteries en autoconsommation.",
  },
  LeadFlow: {
    title:
      "Potentiel Solaire - Étude horaire sur 25 ans {'|'} projetsolaire.com",
    description:
      "Découvrez votre autoconsommation photovoltaïque avec analyse de l'historique horaire du Linky. Gratuit et sans engagements. Zéro démarchage.",
  },
  ResaleAgreements: {
    title: "Comparez les alternatives à EDF OA",
    description:
      "Consultez les alternatives à EDF OA. Choisissez entre un contrat ou une batterie virtuelle et laissez projetsolaire vous accompagner dans votre démarche.",
  },
  About: {
    title:
      "Engagements de l'Acteur Français du Solaire {'|'} projetsolaire.com",
    description:
      "Découvrez la mission et l'équipe du N°1 bureau d'études photovoltaïque en France, et sa vision de l'informatique au service de la filière française du solaire.",
  },
  SolarLeasingHomeOwners: {
    title:
      "Location de panneaux solaires pour particuliers {'|'} projetsolaire.com",
    description:
      "Solaire sans frais initiaux. Paiement mensuel fixe, installation et garantie incluses. Devis personnalisé gratuit.",
  },
  SellSurplusEnergy: {
    title: "Vendez votre surplus d'énergie solaire {'|'} projetsolaire.com",
    description:
      "Gagnez plus que les tarifs de rachat en vendant directement à votre communauté locale. Nous gérons la complexité, vous recevez les paiements.",
  },
  CommunitySolarConsumer: {
    title: "Join a solar community near you {'|'} projetsolaire.com",
    description:
      "Access cheaper local solar energy with no panels required. Join a community near you and reduce your electricity bill while supporting local renewable energy.",
  },
  HelpHome: {
    title:
      "Manuel d'utilisation et astuces - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  LearnCenter: {
    title:
      "Manuel d'utilisation et astuces - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpHouseholder: {
    title:
      "Assistance pour Propriétaires - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderYourAccountGuideParentAll: {
    title: "Votre portail internet - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderPaymentsGuideParentAll: {
    title:
      "Paiements, tarification et remboursements - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderPresentationGuideParentAll: {
    title:
      "Choisir son système solaire - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderQuotingGuideParentAll: {
    title:
      "Choisir son devis sur-mesure - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderTechnicalVisitGuideParentAll: {
    title: "Valider la faisabilité - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderContractGuideParentAll: {
    title: "Investir dans le solaire - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderAdministrationGuideParentAll: {
    title:
      "Réalisation des démarches administratives - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderInstallationGuideParentAll: {
    title: "Pose & mise en service - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideHouseholderLegalGuideParentAll: {
    title: "Mentions juridiques - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpInstaller: {
    title: "Service client pour Pros - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerYourAccountGuideParentAll: {
    title: "Votre compte en ligne - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerPresentationGuideParentAll: {
    title:
      "Études photovoltaïques en ligne - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerQuotingGuideParentAll: {
    title: "Mise en relation - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerAdministrationGuideParentAll: {
    title:
      "Gestion administrative automatisée - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerHardwareGuideParentAll: {
    title: "Planification du matériel - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerPaymentsGuideParentAll: {
    title:
      "Paiements, tarification et remboursements - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerProjectManagementGuideParentAll: {
    title: "Vos projets solaires - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerPostInstallationGuideParentAll: {
    title: "Service après-installation - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  HelpGuideInstallerLegalGuideParentAll: {
    title: "Mentions juridiques - Centre d'aide {'|'} projetsolaire.com",
    description:
      "Besoin d'aide ou vous souhaitez nous contacter ? Retrouvez l'assistance, documentation, articles et vidéos des fonctionnalités web et mobile et des services.",
  },
  Blog: {
    title: "Astuces, Guides, Centre de renseignements {'|'} projetsolaire.com",
    description:
      "Retrouvez tous nos conseils pour financer, optimiser et entretenir vos panneaux solaires. Autoconsommation, économies d'énergies, aides et démarches.",
  },
  BlogHome: {
    title: "Astuces, Guides, Centre de renseignements {'|'} projetsolaire.com",
    description:
      "Notre expertise pour financer, optimiser et entretenir vos panneaux solaires et batteries de stockage. Autoconsommation, économies, aides et démarches.",
  },
  BlogSeries: {
    title: "Astuces, Guides, Centre de renseignements {'|'} projetsolaire.com",
    description:
      "Notre expertise pour financer, optimiser et entretenir vos panneaux solaires et batteries de stockage. Autoconsommation, économies, aides et démarches.",
  },
  BlogArticle: {
    title: "Astuces, Guides, Centre de renseignements {'|'} projetsolaire.com",
    description:
      "Notre expertise pour financer, optimiser et entretenir vos panneaux solaires et batteries de stockage. Autoconsommation, économies, aides et démarches.",
  },
  CareerHome: {
    title: "Impact sur climat | Carrières chez projetsolaire",
    description:
      "Envie d'enfin avoir un impact sur le climat ? Rejoignez-nous pour faire quelque chose de grand. ",
  },
  CareerJobPosts: {
    title: "Opportunités à pourvoir | Carrières chez projetsolaire",
    description:
      "Envie d'enfin avoir un impact sur le climat ? Rejoignez-nous pour faire quelque chose de grand. ",
  },
  CareerJobPost: {
    title: "Opportunités et postes à pourvoir | Carrières chez projetsolaire",
    description:
      "Rejoignez-nous pour faire quelque chose de grand. Nous contribuons à l'avenir de l'énergie propre et décentralisée en France, parmi les plus beaux paysages du monde.",
  },
  CareerJobPostApply: {
    title: "Opportunités et postes à pourvoir | Carrières chez projetsolaire",
    description:
      "Rejoignez-nous pour faire quelque chose de grand. Nous contribuons à l'avenir de l'énergie propre et décentralisée en France, parmi les plus beaux paysages du monde.",
  },
  AmbassadorsHome: {
    title:
      "Parrainez et gagnez 500€ - Programme Ambassadeurs {'|'} projetsolaire.com",
    description:
      "Rejoignez notre programme d'ambassadeurs solaires. Parrainez vos proches et gagnez 500€ par installation. Contribuez à la transition énergétique tout en gagnant de l'argent.",
  },
  AmbassadorsLead: {
    title: "Parlez du solaire et gagnez de l'argent {'|'} projetsolaire.com",
    description:
      "Gagnez des milliers d'euros grâce à projetsolaire avec votre bouche-à-oreille, en obtenant factures élec de vos proches et voisins, puis en parlant d'artisans.",
  },
  InstallerHome: {
    title:
      "Projetsolaire.com {'|'} N°1 de la Gestion tout-en-un photovoltaïque",
    description:
      "Plateforme dimensionnement et administratif pour installateurs de panneaux solaires, artisan RGE, poseur PV, développeur installation photovoltaïque en BT et HTA.",
  },
  InstallerSolarLeasing: {
    title: "Solar leasing for installers {'|'} projetsolaire.com",
    description:
      "Offer monthly solar subscriptions to close more deals with zero upfront cost and quick approvals.",
  },
  InstallerChangelog: {
    title: "Changelog {'|'} projetsolaire.com",
    description:
      "Découvrez les dernières fonctionnalités et améliorations de la plateforme projetsolaire.",
  },
  InstallerMobileAppIOS: {
    title: "Application iOS - Bientôt disponible {'|'} projetsolaire.com",
    description:
      "Restez informé du lancement de notre nouvelle application mobile. Soyez parmi les premiers à découvrir l'avenir de la collaboration solaire sur votre iPhone.",
  },
  InstallerAdministration: {
    title: "N°1 des Démarches Administratives du PV {'|'} projetsolaire.com",
    description:
      "Expert des démarches administratives photovoltaïque. Déléguez et suivez vos dossiers urbanisme, Enedis ou régie ELD, Consuel, EDF OA ou batterie virtuelle.",
  },
  InstallerAdministrationMayor: {
    title: "DP et PC pour Autorisation Mairie {'|'} projetsolaire.com",
    description:
      "Autorisation urbanisme solaire en déclaration préalable ou permis de construire.",
  },
  InstallerAdministrationGridConnection: {
    title:
      "Demande de raccordement  solaire en BT et HTA {'|'} projetsolaire.com",
    description:
      "Démarche Enedis ou ELD avec PTF pour mise en service. Démarche EDF OA ou batterie virtuelle ou ARPE",
  },
  InstallerAdministrationConsuel: {
    title:
      "Attestation Conformité Consuel bleu et violet {'|'} projetsolaire.com",
    description:
      "Logiciel et prestations obtention AC Consuel, schéma unifilaire, SC144 et bureau de contrôle",
  },
  InstallerAdministrationServiceOutline: {
    title:
      "Solution à la carte des Démarches Administratives {'|'} projetsolaire.com",
    description:
      "Expert des démarches administratives photovoltaïque. Déléguez et suivez vos dossiers urbanisme, Enedis ou régie ELD, Consuel, EDF OA ou batterie virtuelle.",
  },
  InstallerDigitalSalesTools: {
    title: "Logiciel de Dimensionnement Solaire PV {'|'} projetsolaire.com",
    description:
      "Études photovoltaïques avec données horaires de consommation du compteur Linky, productible avec masque d'ombres pour audit RGE, en marque blanche.",
  },
  InstallerQuote: {
    title: "Gestion de Devis Intégrés aux Ventes {'|'} projetsolaire.com",
    description:
      "Créez et envoyez des devis en quelques secondes. Joignez des devis aux présentations, personnalisez les prix, recueillez les signatures électroniques et traitez les paiements dans un flux de travail fluide.",
  },
  InstallerCustomerPortal: {
    title:
      "Portail Client Personnalisables et en Marque Blanche {'|'} projetsolaire.com",
    description:
      "Augmentez les taux de conversion et réduisez les allers-retours grâce à un portail avec vos couleurs qui tient vos clients informés à chaque étape du processus. Suivi en temps réel, centre de documentation et intégration transparente.",
  },
  InstallerDesign: {
    title: "Dimensionnement avec projetsolaire",
    description:
      "Nous travaillons avec Aurora solar afin de vous offrir la solution la plus polyvalente et qualitative pour les dimensionnement de vos clients.",
  },
  InstallerFindNewClients: {
    title: "Mise en relation leads PV sans commissions {'|'} projetsolaire.com",
    description:
      "Plateforme en ligne d'appel d'offres pour chantiers photovoltaïques. Le poseur choisit le prix et le matériel. La visite technique est obligatoire.",
  },
  InstallerCaseStudiesHomeOverview: {
    title:
      "Études de cas et Témoignages toutes tailles {'|'} projetsolaire.com",
    description:
      "Avis sur projetsolaire de professionnels, installateurs, poseurs et développeurs du photovoltaïque, cas d'usage sur chantiers HTA, BT>36, particulier.",
  },
  InstallerCaseStudiesHomeAll: {
    title:
      "Tous les témoignages de pros de toutes tailles {'|'} projetsolaire.com",
    description:
      "Avis sur projetsolaire de professionnels, installateurs, poseurs et développeurs du photovoltaïque, cas d'usage sur chantiers HTA, BT>36, particulier.",
  },
  Pricing: {
    title: "Tarifs, prix et coût pour Professionnels {'|'} projetsolaire.com",
    description:
      "Grille tarifaire de projetsolaire et des services numériques, démarches administratives, études, mise en relation, plateforme de gestion de chantiers.",
  },
  ToolsHome: {
    title:
      "Outils gratuits pour installation photovoltaïque {'|'} projetsolaire.com",
    description:
      "Expert du photovoltaïque et N°1 bureau d'études en France, développe outils en ligne et simulateurs, gratuit et libre d'accès pour installation de panneaux solaires.",
  },
  ToolEnedisConstructionCost: {
    title:
      "Simulateur Coûts Travaux Raccordement Enedis - Outil gratuit {'|'} projetsolaire.com",
    description:
      "Calcul du coût du renforcement du réseau électrique BT et HTA par Enedis. Alternative au devis PTF de la demande de raccordement photovoltaïque.",
  },
  ToolCarbonModelCalculator: {
    title:
      "Calcul Impact CO2e du Solaire - Outil gratuit {'|'} projetsolaire.com",
    description:
      "Expert du photovoltaïque et N°1 bureau d'études en France, développe outils en ligne et simulateurs, gratuit et libre d'accès pour installation de panneaux solaires.",
  },
  ToolQuoteChecker: {
    title:
      "Vérifier Devis Photovoltaïque - Outil gratuit {'|'} projetsolaire.com",
    description:
      "Expert du photovoltaïque et N°1 bureau d'études en France, développe outils en ligne et simulateurs, gratuit et libre d'accès pour installation de panneaux solaires.",
  },
  ToolHistoricalMonumentChecker: {
    title:
      "Vérifier Urbanisme et Zone ABF - Outil gratuit {'|'} projetsolaire.com",
    description:
      "Expert du photovoltaïque et N°1 bureau d'études en France, développe outils en ligne et simulateurs, gratuit et libre d'accès pour installation de panneaux solaires.",
  },
  Support: {
    title: "Service Client et Contact {'|'} projetsolaire.com",
    description:
      "Discutez avec nos équipes aujourd'hui. Service client 360° disponible via chat, email, téléphone, SMS, et visio. Disponible tous les jours ouvrés sur l'année.",
  },
  SupportSchedule: {
    title: "Service Client et Contact {'|'} projetsolaire.com",
    description:
      "Discutez avec nos équipes aujourd'hui. Service client 360° disponible via chat, email, téléphone, SMS, et visio. Disponible tous les jours ouvrés sur l'année.",
  },
  DynamicFormAdministration: {
    title: "Formulaire en ligne pour liasse administrative photovoltaïque",
    description:
      "Renseignez les informations du formulaire en ligne pour réussir le dépôt du dossier auprès de l'administration française.",
  },
  DynamicFormLead: {
    title: "Formulaire en ligne pour étude technico-financière du solaire",
    description:
      "Renseignez les informations du formulaire en ligne pour réussir l'étude de rentabilité de l'autoconsommation.",
  },
  DynamicFormEnedisConsumptionPermission: {
    title: "Formulaire en ligne pour consentment au données Linky",
    description:
      "Renseignez les informations du formulaire en ligne pour réussir l'analyse horaire de l'autoconsommation du site.",
  },
  GetBestPrice: {
    title: "Meilleur prix devis {'|'} projetsolaire.com",
    description:
      "Obtenez le meilleur prix pour votre projet solaire. Partagez votre devis ou déposez votre fichier, nous vous recontactons sous peu.",
  },
  SignUp: {
    title: "Inscription {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France développe la première plateforme d'appel d'offres pour installation panneaux solaires, démarches administratives.",
  },
  SignUpCallback: {
    title: "Confirmation inscription {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France développe la première plateforme d'appel d'offres pour installation panneaux solaires, démarches administratives.",
  },
  EnableAccountCallback: {
    title: "Activation de votre compte {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France développe la première plateforme d'appel d'offres pour installation panneaux solaires, démarches administratives.",
  },
  SignIn: {
    title: "Connexion {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France développe la première plateforme d'appel d'offres pour installation panneaux solaires, démarches administratives.",
  },
  AdminSignIn: {
    title: "Accès privé",
    description:
      "Ne partagez jamais votre mot de passe. Votre mot de passe n'est jamais demandé ailleurs que lors de votre connexion.",
  },
  SupplierSignIn: {
    title: "Connexion - Portail Fournisseurs {'|'} projetsolaire.com",
    description: "Connexion - Fournisseurs description",
  },
  AmbassadorSignIn: {
    title: "Connexion - Portail Ambassadeurs {'|'} projetsolaire.com",
    description: "Connexion - Ambassadeurs description",
  },
  ArchitectSignIn: {
    title: "Connexion - Portail Architecte {'|'} projetsolaire.com",
    description: "Connexion - Architecte description",
  },
  VirtualBatteryProviderSignIn: {
    title: "Connexion - Portail Batterie Virtuelle {'|'} projetsolaire.com",
    description: "Connexion - Batterie Virtuelle description",
  },
  ResetPassword: {
    title: "Réinitialisation du mot de passe {'|'} projetsolaire.com",
    description: "Réinitialiser le mot de passe description",
  },
  ResetPasswordSupplier: {
    title:
      "Réinitialisation du mot de passe - Fournisseurs {'|'} projetsolaire.com",
    description: "Réinitialiser le mot de passe - Fournisseurs description",
  },
  ResetPasswordCallback: {
    title: "Réinitialisation du mot de passe - Callback",
    description: "La plateforme est sécurisé",
  },
  InviteCallbackInstaller: {
    title: "Invitation au compte de l'entreprise {'|'} projetsolaire.com",
    description:
      "Compte personnel pour la gestion de chantiers photovoltaïques. Mise à disposition gratuitement par le bureau d'études numérique français projetsolaire.com",
  },
  InviteCallbackArchitect: {
    title: "Invitation au compte de l'entreprise {'|'} projetsolaire.com",
    description:
      "Compte personnel pour la gestion de chantiers photovoltaïques. Mise à disposition gratuitement par le bureau d'études numérique français projetsolaire.com",
  },
  InviteCallbackVirtualBatteryProvider: {
    title: "Invitation au compte de l'entreprise {'|'} projetsolaire.com",
    description:
      "Compte personnel pour la gestion de chantiers photovoltaïques. Mise à disposition gratuitement par le bureau d'études numérique français projetsolaire.com",
  },
  InviteCallbackSupplier: {
    title: "Invitation au portail e-commerce {'|'} projetsolaire.com",
    description:
      "Compte de E-commerce en ligne pour vente de matériel photovoltaïque. Mise à disposition gratuitement par le bureau d'études numérique français projetsolaire.com",
  },
  InviteCallbackUser: {
    title:
      "Invitation à l'espace client de son projet solaire {'|'} projetsolaire.com",
    description:
      "Portail client de suivi en ligne de son projet solaire. Mise à disposition gratuitement par le bureau d'études numérique français projetsolaire.com",
  },
  ReportsHome: {
    title: "Rapport du Solaire en France {'|'} projetsolaire.com",
    description:
      "Le N°1 bureau d'études photovoltaïque en France publie son rapport annuel. Découvrez les tendances, renseignements et données de la filière photovoltaïque.",
  },
  Reports2023: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023Home: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023Introduction: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023MarketEvolution: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023BarometreConsommateurs: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023Hardware: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023Reglementation: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023Ecodelinquance: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023Co2EnergyMix: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  Reports2023AboutProjetsolaire: {
    title: "Rapport Annuel du Solaire en France {'|'} projetsolaire.com",
    description:
      "Découvrez les évolutions de l'énergie solaire. Tendances, renseignements, et données de la filière du photovoltaïque et du stockage en France.",
  },
  HardwareMarketplaceShopHome: {
    title:
      "Achat en ligne et Distribution Matériel Photovoltaïque {'|'} projetsolaire.com",
    description:
      "Découvrez prix compétitifs 100% en ligne module PV, onduleurs, batteries, équipements en énergie solaire.",
  },
  HardwareMarketplace: {
    title: "Commandez en ligne votre Matériel Solaire  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceAbout: {
    title: "Commandez en ligne votre Matériel Solaire  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceSupport: {
    title: "Service client pour Commandes en ligne {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceCompare: {
    title: "Comparez le Matériel Solaire en ligne {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceCollection: {
    title: "Commandez en ligne votre Matériel Solaire  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceCollectionManufacturer: {
    title: "Comparez Marques de Matériel Solaire  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceShopManufacturers: {
    title: "Comparez Marques de Matériel Solaire  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceShopSuppliers: {
    title: "Comparez offres de Matériel Solaire {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceShopSupplier: {
    title: "Comparez offres de Matériel Solaire {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceShopProducts: {
    title: "Commandez en ligne votre Matériel Solaire  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceShopProduct: {
    title: "Commandez en ligne votre Matériel Solaire  {'|'} projetsolaire.com",
    description:
      "L'Entrepôt est le webshop e-commerce des professionnels du photovoltaïque et du stockage : modules, onduleurs, systèmes de fixation, batteries.",
  },
  HardwareMarketplaceCompareParent: {
    title:
      "Achat en ligne et Distribution Matériel Photovoltaïque {'|'} projetsolaire.com",
    description:
      "Découvrez prix compétitifs 100% en ligne module PV, onduleurs, batteries, équipements en énergie solaire.",
  },

  InstallerUseCaseSmall: {
    title:
      "Logiciel PV ventes, DP, Consuel pour artisans {'|'} projetsolaire.com",

    description:
      "App de gestion photovoltaïque pour pro RGE. Données Linky, calepinage, étude rentabilité, devis, administratif, etc. sur 1 seul outil.",
  },

  InstallerUseCaseRegional: {
    title:
      "Logiciel PV pour installateur photovoltaïque PME {'|'} projetsolaire.com",

    description:
      "CRM et ERP de gestion chantiers. Données Linky, dimensionnement calepinage, étude rentabilité avec stockage, devis, agenda, ADV, etc. sur 1 seul outil.",
  },

  InstallerUseCaseNational: {
    title:
      "Logiciel pour ETI de gestion de chantiers PV {'|'} projetsolaire.com",

    description:
      "Plateforme tout-en-un photovoltaïque et stockage. Données Linky, dimensionnement, étude rentabilité, urbanisme, raccordement, etc. sur 1 seul outil.",
  },

  InstallerUseCaseSelfInstallation: {
    title:
      "Logiciel PV avec simulateur, ventes, DP, Enedis {'|'} projetsolaire.com",

    description:
      "CRM et ERP photovoltaïque en marque blanche. Données Linky, calepinage, étude rentabilité sur-mesure, devis, administratif, etc. sur 1 seul outil.",
  },

  InstallerUseCaseFranchise: {
    title: "Logiciel PV Ventes et Gestion franchises {'|'} projetsolaire.com",

    description:
      "CRM et ERP photovoltaïque de gestion réseau franchises. Données Linky, dimensionnement, étude rentabilité, devis, ADV, etc. sur 1 seul outil.",
  },

  InstallerUseCaseDeveloper: {
    title:
      "Logiciel Développement PV et Tiers investisseurs {'|'} projetsolaire.com",

    description:
      "CRM et ERP suivi chantiers photovoltaïques et gestion SPV. Données Linky, dimensionnement et productible, AVP, PC, T0, CRD etc. sur 1 seul outil.",
  },

  InstallerUseCaseCommercialRegie: {
    title:
      "Mise en relation régie commerciale et sous-traitants PV {'|'} projetsolaire.com",
    description:
      "Donneur d’ordres en recherche d’installateurs pour la pose solaire ? Accédez au réseau projetsolaire : sous-traitance, outils et gestion de chantiers.",
  },

  InstallerUseCaseManufacturerSupplier: {
    title:
      "Fabricant ou fournisseur de matériel photovoltaïque {'|'} projetsolaire.com",
    description:
      "Vous êtes vendeur de matériel ? Découvrez comment vendre directement à des milliers d’installateurs avec projetsolaire.",
  },

  InstallerUseCaseEnergySupplier: {
    title:
      "Fournisseur d'énergie présent dans le solaire {'|'} projetsolaire.com",
    description:
      "Vous proposez des solutions EMS ? Découvrez comment les fournisseurs d'énergie utilisent projetsolaire pour innover plus rapidement.",
  },

  InstallerUseCasesHome: {
    title:
      "Étude de cas du Logiciel Photovoltaïque CRM/ERP {'|'} projetsolaire.com",
    description:
      "Découvrez la suite de solutions de gestion et suivi de chantiers utilisée par nos centaines de clients artisans, installateurs et développeurs.",
  },
  InstallerHostedPageParent: {
    title:
      "Entreprise de panneaux solaires dans le {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Optez pour une entreprise de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  InstallerHostedPageOnboard: {
    title:
      "Entreprise de panneaux solaires dans le {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Optez pour une entreprise de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  InstallerHostedPageOnboardCallback: {
    title:
      "Entreprise de panneaux solaires dans le {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Optez pour une entreprise de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  InstallerHostedPageSignIn: {
    title:
      "Entreprise de panneaux solaires dans le {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Optez pour une entreprise de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  InstallerHostedPageInviteCallback: {
    title:
      "Entreprise de panneaux solaires dans le {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Optez pour une entreprise de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  MyLight150MySmartBattery: {
    title: "MySmartBattery par mylight150 : tarifs et conditions",
    description:
      "Comparez l'offre de Batterie virtuelle mylight150 avec coffret de pilotage, avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  MyLight150MyBattery: {
    title: "MyBattery par mylight150 : tarifs et conditions",
    description:
      "Comparez l'offre de Batterie virtuelle mylight150 en illimité, sans matériel, avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  UrbanSolarEnergyBatteryIndividuals: {
    title: "Stockage virtuel par Urban Solar Energy : tarifs et conditions",
    description:
      "Comparez l'offre de Batterie virtuelle Urban Solar Energy en illimité, sans matériel, avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  UrbanSolarEnergyBatteryVirtualProfessional: {
    title: "Stockage virtuel pour Pros par Urban Solar : tarifs et conditions",
    description:
      "Comparez l'offre pour le Professionnel de batterie virtuelle Urban Solar en illimité, avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  UrbanSolarEnergyBoostProductionLessThan36kva: {
    title: "Boost My Surplus avec Urban Solar Energy : tarifs et conditions",
    description:
      "Comparez l'offre de Rachat de production (<36 kVA) de Urban Solar Energy avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  UrbanSolarEnergyBoostProductionPlus36kva: {
    title: "Boost My Surplus avec Urban Solar Energy: tarifs et conditions",
    description:
      "Comparez l’offre de Rachat de production (+36 kVA) de Urban Solar Energy avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  OctopusEnergyPurchaseContractForIndividuals: {
    title:
      "Offre de rachat SolarPlus par Octopus Energy : tarifs et conditions",
    description:
      "Comparez l'offre du Fournisseur d'énergie Octopus de Tarif d’Achat et de pilotage avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  // does not have a page
  OctopusEnergy: {
    title: "Octopus Energy pour Tertiaire : tarifs et conditions",
    description:
      "Comparez l'offre du Fournisseur d'énergie Octopus de Tarif d’Achat pour le Tertiaire avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  // does not have a page
  MintEnergy: {
    title: "Rachat d'électricité par Mint Énergie : tarifs et conditions",
    description:
      "Comparez l'offre de Rachat de surplus solaire du Fournisseur d'énergie Mint Solaire avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  EkwateurSurplusWithContract: {
    title: "Vente de production à Ekwateur avec contrat : tarifs et conditions",
    description:
      "Comparez l'offre de Rachat du surplus du Fournisseur d'énergie Ekwateur avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  EkwateurSurplusWithoutContract: {
    title: "Vente de production à Ekwateur sans contrat : tarifs et conditions",
    description:
      "Comparez l'offre de Rachat du surplus du Fournisseur d'énergie Ekwateur avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  Kwatts: {
    title:
      "Contrat d’achat par Kwatts au prix de marché : tarifs et conditions",
    description:
      "Comparez l'offre de Kwatts, sans abonnement, de rachat au Prix de la RTE avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  "3ERL": {
    title: "Contrat d’achat par 3ERL au prix de marché : tarifs et conditions",
    description:
      "Comparez l'offre de l’association 3E-RL responsable d’équilibre au Prix de la RTE avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  JPMEEsurplusFixedForIndividuals: {
    title: "E-Surplus Fixe pour Particuliers par JPME : tarifs et conditions",
    description:
      "Comparez l’offre de Je Produis Mon Énergie de rachat au Prix fixe de production avec d'autres offres d'énergie solaire photovoltaïque.",
  },
  JPMEEsurplusFlexForIndividuals: {
    title: "E-Surplus Flex pour Particuliers par JPME : tarifs et conditions",
    description:
      "Comparez l’offre de Je Produis Mon Énergie d'achat au Prix du marché de production avec d'autres offres d'énergie solaire photovoltaïque.",
  },
  JPMEEsurplusFixedForProfessionals: {
    title: "E-Surplus Fixe pour Professionnels par JPME : tarifs et conditions",
    description:
      "Comparez l’offre de Je Produis Mon Énergie de rachat au Prix fixe de production avec d'autres offres d'énergie solaire photovoltaïque.",
  },
  JPMEEsurplusFlexForProfessionals: {
    title: "E-Surplus Flex pour Professionnels par JPME : tarifs et conditions",
    description:
      "Comparez l’offre de Je Produis Mon Énergie d'achat de production au Prix du marché avec d'autres offres d'énergie solaire photovoltaïque.",
  },
  JPMEEbatteryIndividualsLessThan15KVA: {
    title: "E-batterie par JPME pour particuliers : tarifs et conditions",
    description:
      "Comparez l'offre de Batterie virtuelle (jusqu’à 15 kVA) de Je Produis Mon Énergie avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  JPMEEbatteryIndividualsThreePhase: {
    title: "E-batterie par JPME pour particuliers : tarifs et conditions",
    description:
      "Comparez l'offre de Batterie virtuelle (en triphasé) de Je Produis Mon Énergie avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  JPMEEbatteryLowVoltage: {
    title: "E-batterie JPME en basse tension : tarifs et conditions",
    description:
      "Comparez l'offre de Batterie virtuelle (en BT>36) de Je Produis Mon Énergie avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  JPMEEbatteryHighVoltage: {
    title: "E-batterie JPME en haute tension : tarifs et conditions",
    description:
      "Comparez l'offre de Batterie virtuelle (en HTA) de Je Produis Mon Énergie avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  MKSurplusWithValidate: {
    title:
      "Contrat d’achat MK-surplus par MonKitSolaire : tarifs et conditions",
    description:
      "Comparez l'offre de Vente de votre production (avec Consuel) de MonKitSolaire avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  MKSurplusWithoutValidate: {
    title:
      "Contrat d’achat MK-surplus par MonKitSolaire : tarifs et conditions",
    description:
      "Comparez l'offre de Vente de votre production (sans Consuel) de MonKitSolaire avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  Sunology: {
    title: "Surplus + par Sunology : tarifs et conditions",
    description:
      "Comparez l'offre de Offre de rachat du surplus de votre installation solaire à un prix fixe avec Sunology avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  ResaleAgreementEDFOA: {
    title: "EDF OA Obligation Achat sur 20 ans (S21) : tarifs et conditions",
    description:
      "Comparez l'offre de Tarif d'achat garanti par l'État en métropole ou DROM-COM avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  ResaleAgreementTotalEnergies: {
    title:
      "Tarif d’achat Obligation Achat par Total Energies : tarifs et conditions",
    description:
      "Comparez l'offre de Contrat d'achat hors obligation achat par le Fournisseur d'énergie avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  OhmEnergie: {
    title:
      "Batterie virtuelle Ohm du fournisseur d'énergie : tarifs et conditions",
    description:
      "Comparez l'offre de Batterie virtuelle Ohm en illimité, sans matériel, avec d'autres offres de production d'énergie solaire photovoltaïque.",
  },
  InstallerDirectory: {
    title:
      "Trouvez votre Artisan RGE sur l'Annuaire Solaire Photovoltaïque | projetsolaire.com",
    description:
      "Optez pour un artisan de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  InstallerDirectoryDepartmentSelect: {
    title:
      "Trouvez votre Artisan RGE sur l'Annuaire Solaire Photovoltaïque | projetsolaire.com",
    description:
      "Optez pour un artisan de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  InstallerDirectoryDepartmentResults: {
    title:
      "Installateurs de panneaux solaires dans {departmentName} ({departmentCode}) | projetsolaire.com",
    description:
      "Optez pour un artisan de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  InstallerDirectoryInstallerProfile: {
    title:
      "{commercialName} dans {departmentName} ({departmentCode}) : avis et contact | projetsolaire.com",
    description:
      "Optez pour un artisan de proximité. Réduisez votre facture d'électricité grâce aux panneaux solaires dernière génération avec batteries.",
  },
  MarketplacePartnerHome: {
    title: "Partenaires Marketplace",
    description:
      "Rejoignez notre marketplace de partenaires photovoltaïques. Connectez-vous avec des professionnels du solaire et développez votre activité.",
  },
  MarketplaceHome: {
    title:
      "Nouveaux prospects solaires & chantiers photovoltaïques | Marketplace solaire | projetsolaire.com",
    description:
      "Découvrez de nouveaux prospects pour des installations solaires et des chantiers photovoltaïques en France. Connectez-vous avec des clients qualifiés à la recherche d’installateurs professionnels.",
  },
  MarketplaceTenderDetails: {
    title:
      "Nouveau prospect solaire {size}kWc à {emplacement} | projetsolaire.com",
    description:
      "Chantier d’installation solaire de {size}kWc disponible à {location}.Connectez-vous avec ce prospect qualifié et développez votre activité photovoltaïque dès aujourd’hui.",
  },
}
